export default {"src":"/_next/static/media/Porsche_Wortmarke_1.16907a0b.svg","height":26,"width":210,"blurWidth":0,"blurHeight":0};